import { reactive, ref } from "vue";

/**
 * 政府网站友情链接
 */
export const friendlyLink = reactive([
  {
    value: 1,
    label: '山东省健康委员会',
    link: 'http://wsjkw.shandong.gov.cn/',
    image: require('@/assets/friendly/wsjkw.png')
  },
  {
    value: 2,
    label: '山东省社会组织管理局',
    link: 'http://mzt.shandong.gov.cn/sdnpo/',
    image: require('@/assets/friendly/mzt.png')
  },
  {
    value: 3,
    label: '山东省科学技术协会',
    link: 'http://www.sdast.org.cn/',
    image: require('@/assets/friendly/sdast.png')
  },
  {
    value: 4,
    label: '山省社会组织总会',
    link: 'http://www.sdshzz.org/',
    image: require('@/assets/friendly/sdshzz.png')
  },
  {
    value: 5,
    label: '中国神经科学学会',
    link: 'https://www.cns.org.cn/',
    image: require('@/assets/friendly/zgsjkxxh.png')
  },
])

export const brotherLink = reactive([
  {
    value: 1,
    label: '中国神经科学学会',
    link: 'https://www.cns.org.cn/',
    image: ''
  },
  {
    value: 2,
    label: '山东省医学会',
    link: 'https://www.shdma.com/',
    image: ''
  },
  {
    value: 3,
    label: '山东省医院协会',
    link: 'http://www.sdsyyxh.com/',
    image: ''
  },
  {
    value: 4,
    label: '山东省医师协会',
    link: 'http://www.sdmda.org.cn/#/',
    image: ''
  },
  {
    value: 5,
    label: '山东省护理学会',
    link: 'http://www.sdhlxh.com/',
    image: ''
  },
  {
    value: 6,
    label: '山东省康复医学会',
    link: 'http://www.sdarm.org.cn/',
    image: ''
  },
  {
    value: 7,
    label: '山东省公共卫生学会',
    link: 'https://sdph.org.cn/',
    image: ''
  },
  {
    value: 8,
    label: '山东省基层卫生协会',
    link: 'https://www.sdsjcwsxh.com/',
    image: ''
  },
  {
    value: 9,
    label: '山东省老年医学学会',
    link: 'http://www.sdsasg.com/',
    image: ''
  },
])